import { render } from "./ProfileCardScores.vue?vue&type=template&id=2a04bfe4&scoped=true"
import script from "./ProfileCardScores.vue?vue&type=script&lang=js"
export * from "./ProfileCardScores.vue?vue&type=script&lang=js"

import "./ProfileCardScores.vue?vue&type=style&index=0&id=2a04bfe4&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a04bfe4"]])

export default __exports__